export const lanList = ['tw', 'en', 'jp'];

export const LANGUAGE_NAME_MAP = {
	tw: '繁體中文',
	en: 'English',
	jp: '日文',
};
